interface WorklistPaginationProps {
  page: number;
  limit: number;
  totalPages: number;
  busy: boolean;
  onLimitChange: (limit: number) => void;
  onPrev: () => void;
  onNext: () => void;
}

export const WorklistPagination = ({ page, limit, totalPages, busy, onLimitChange, onPrev, onNext }: WorklistPaginationProps) => (
  <div className="pagination investigation-bill-pagination">
    <label>Rows <select value={limit} disabled={busy} onChange={(event) => onLimitChange(Number(event.target.value))}><option value={20}>20</option><option value={50}>50</option><option value={100}>100</option><option value={500}>500</option></select></label>
    <button className="button button-secondary" disabled={busy || page <= 1} onClick={onPrev}>Previous</button>
    <span>Page {page} of {Math.max(totalPages, 1)}</span>
    <button className="button button-secondary" disabled={busy || page >= totalPages} onClick={onNext}>Next</button>
  </div>
);
